import store from "../redux/store";

export function generateRandomColor() {
    const letters = '0123456789ABCDEF';
    let color = '#';
    for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
}

export const getRandomColor = () => `hsl(${Math.floor(Math.random() * 360)}, 70%, 50%)`;

export const fabStyle = {
    borderRadius: '50px',
    bgcolor: '#ffff',
    color: 'black',
    boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.15)',
    '& .MuiOutlinedInput-root': {
        // height: '40px', 
        minHeight: '43px', 
        borderRadius: '50px',
        display: 'flex',
        alignItems: 'center',
        '& fieldset': {
            // border: 'none',
        },
    },
    '& input': {
        color: '#4a4a4a',
        textAlign: 'left',
        padding: '10px 14px', 
    },
    '& input::placeholder': {
        color: '#4a4a4a',
        opacity: 1,
    },
};
  

interface OrganizationTypeOption {
    value: string;
    label: string;
}
export const organizationTypes: OrganizationTypeOption[] = [
    { value: 'admin', label: 'Admin' },
    { value: 'agent', label: 'Call Agent' },
];

export const phoneRegex = /^(?:\+91[-\s]?|0)?[6-9]\d{9}$/;
export const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export const GetUserType = () => {
    const authUser = store.getState().authUser;
    if (!authUser) return 'agent';
    return authUser?.user_details?.user_type
}

export const roundedInputBoxStyle = (height: string) => ({
    backgroundColor: 'white',
    borderRadius: '50px',
    border: 'none',
    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.25)',
    '& .MuiOutlinedInput-root': {
        borderRadius: '50px',
        height: height,
        paddingRight: '10px',
        display: 'flex',
        alignItems: 'center',

        '& input::placeholder': {
            color: '#00a6ff',
            fontWeight: 500,
            fontSize: '0.9rem',
            fontFamily: "'Consolas', sans-serif",
            opacity: 1, 
        },
    },
});
  